import { Fragment, useState } from "react";
import { Tooltip } from "react-tooltip";
import { Menu, MenuButton, Transition, MenuItems, MenuItem, Button } from "@headlessui/react";
import { useAppSelector } from "../../app/hooks";
import { UserRole } from "../../app/userSlice";
import SupportIcon from "../../assets/SupportIcon";
import SupportLink from "../../components/SupportLink";
import ModalFrame from "../../components/ModalFrame";
import ContactSupportForm from "./ContactSupportForm";

export default function SupportMenu() {
	const { role } = useAppSelector((state) => state.user);

	const [isContactSupportDialogOpen, setIsContactSupportDialogOpen] = useState(false);

	function handleClose() {
		setIsContactSupportDialogOpen(false);
	}

	return role === UserRole.Writer ? (
		<SupportLink id="header-support-center">
			<div
				data-tooltip-id="support-icon-tooltip"
				className="h-10 w-10 flex justify-center items-center rounded-full bg-white/10 ring-2 ring-white/10 hover:bg-white/30 hover:ring-white/60 hover:opacity-85 focus:outline-hidden focus:ring-2 focus:ring-white">
				<SupportIcon className="size-10 stroke-white" aria-label="Support Center" />
			</div>
			<Tooltip
				id="support-icon-tooltip"
				place="bottom-end"
				content="Support Center"
				className="z-40"></Tooltip>
		</SupportLink>
	) : (
		<section>
			<Menu as="div">
				<MenuButton id="support-button" className="flex justify-center items-center">
					<div
						data-tooltip-id="support-menu-tooltip"
						className="h-10 w-10 overflow-hidden cursor-pointer flex justify-center items-center rounded-full bg-white/10 ring-2 ring-white/10 hover:bg-white/30 hover:ring-white/60 hover:opacity-85 focus:outline-hidden focus:ring-2 focus:ring-white">
						<SupportIcon className="size-10 stroke-white" aria-label="Support Menu" />
					</div>
					<Tooltip
						id="support-menu-tooltip"
						place="bottom-end"
						content="Support Center"
						className="z-40"></Tooltip>
				</MenuButton>
				<Transition
					as={Fragment}
					leave="transition ease-in duration-75"
					leaveFrom="transform opacity-100 scale-100"
					leaveTo="transform opacity-0 scale-95">
					<MenuItems
						anchor="bottom end"
						className="absolute -right-2 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-hidden hover:cursor-pointer">
						<div>
							<MenuItem key="support-center">
								<SupportLink
									id="header-support-center"
									className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
									Go to Support Center
								</SupportLink>
							</MenuItem>
						</div>
						<div>
							<MenuItem as="div" key="contact-support">
								<Button
									id="contact-support-button"
									className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
									onClick={() => setIsContactSupportDialogOpen(true)}>
									Contact the Help Desk
								</Button>
							</MenuItem>
						</div>
					</MenuItems>
				</Transition>
			</Menu>
			<ModalFrame
				open={isContactSupportDialogOpen}
				title="Contact Support"
				onClose={handleClose}
				children={<ContactSupportForm onClose={handleClose} />}
			/>
		</section>
	);
}
